import React from "react";

import { Button, Icon, IconProps } from "components";

interface GuidanceLinkProps {
  dataTestId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  text: string;
  disabled?: boolean;
  variant?: "grey" | "light";
  iconSize?: IconProps["size"];
}

export const GuidanceLink = ({ disabled, onClick, text, variant, iconSize }: GuidanceLinkProps) => (
  <Button
    type="text"
    disabled={disabled}
    className={`guidance-link ${variant ?? ""}`}
    onClick={onClick}
    icon={<Icon iconName="tabler/info-circle" size={iconSize} />}
  >
    <div className="guidance-link-content">{text}</div>
  </Button>
);
